import request from '../../../util/SuperagentUtils'
import Request from 'superagent';
import { accountEditEndpoints } from '../../../requests/api-endpoints';

export const updateAccount = (account) => {
    return Request.post(accountEditEndpoints.account.update, account);
};

export const getAllBuyerAccounts = () => {
    return request.get('/api/account/buyers');
};

export const confirmTermsOfService = (accountId, account) => {
    return Request.post(accountEditEndpoints.conformToS(accountId)).send(account);
}

export const getAccountUsers = (accountId: string) => {
    return Request.get(accountEditEndpoints.accountUser.get(accountId));
};

export const createNewUser = (user) => {
  return Request.post(accountEditEndpoints.accountUser.create, user);
};

export const updateExistingUser = (user) => {
    return request.put(accountEditEndpoints.accountUser.update).send(user);
}

export const deleteUser = (user) => {
    return Request.delete(accountEditEndpoints.accountUser.remove, user);
};

export const requestCognitoTokenForUser = (
    accountId: String,
    username: String): Promise<Object> => {

    if (accountId && username) {
        return request
            .get(accountEditEndpoints.cognitoToken(accountId))
            .query({ email: username })
    } else {
        console.error("Attempting request for cognito token with invalid account id or username")
    }
}

export const createAccountFundingSource = (account: {
    id: string,
    newFundingSourceBankAccountType: string,
    newFundingSourceBankRoutingNumber: string,
    newFundingSourceBankAccountNumber: string,
    newFundingSourceAccountNickname?: string}
) => {
    return request.post(accountEditEndpoints.fundingSources.create).send(account);
};

export const removeAccountFundingSource = (accountId: String, onSuccess: Function, onError: Function) => {
    return request.del(accountEditEndpoints.fundingSources.remove(accountId))
        .then((resp) => onSuccess(resp.body))
        .catch((err) => onError(err));
}

export const requestUpdateUserAccessibleLocations = (accountId: String, username: String, locationIds: Array<String>) : Promise => {
    return request
      .put(accountEditEndpoints.updateUserAccessibleLocations(accountId))
      .send({username, locationIds})
}

export const requestEmailVerificationToken = () => {
  return Request.post(accountEditEndpoints.verificationEmail);
};
